import React from "react";

const PopUp = ({id, width, height, switchOn, children}) => {
  return (
    <div className={`prompt-card-fit-div ${switchOn ? "on" : "off"}`}>
      <div
        className="prompt-card"
        id={id}
        style={{
          width: `${width}vw`,
          height: `${height}vh`,
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default PopUp;
